import { render, staticRenderFns } from "./surveyWatchInfo.vue?vue&type=template&id=dc745410"
import script from "./surveyWatchInfo.vue?vue&type=script&lang=js"
export * from "./surveyWatchInfo.vue?vue&type=script&lang=js"
import style0 from "./surveyWatchInfo.vue?vue&type=style&index=0&id=dc745410&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports